<script setup>

</script>

<template>
  <div class="nav-header-h1">
    <h1>South Africa's Most Wanted Criminals</h1>
  </div>

</template>

<style scoped>
  .nav-header-h1 h1{
    color:#DCD700;
    font-family: 'Metal Mania',sans-serif;
    text-align: center;
    padding: 25px 10px 0 10px;
  }
</style>